var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{attrs:{"label":_vm.label,"color":_vm.color,"true-value":'true',"false-value":'false',"hide-details":""},on:{"change":_vm.onSwitch},model:{value:(_vm.bool),callback:function ($$v) {_vm.bool=$$v},expression:"bool"}})}
var staticRenderFns = []

export { render, staticRenderFns }